<template>
  <div class="lang-switcher">
    <button :class="{isActive: lang === 'en'}" @click="setEditorLang('en')">EN</button> |
    <button :class="{isActive: lang === 'de'}" @click="setEditorLang('de')">DE</button>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  methods: {
    ...mapMutations(["setEditorLang"])
  },
  computed: {
    ...mapState(["lang"])
  }
};
</script>

<style lang="scss" scoped>
.lang-switcher {
  button {
    cursor: pointer;
    background: none;
    border: none;

    &.isActive {
      color: #00bfff;
    }
  }
}
</style>
